const routes = [
    {
        path: "/course-merge-sections-list",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "mergesection_index"
        }
    }
];

export default routes;
